import React, {PureComponent} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {SSO_TYPE_SAML} from "@irati/sso/constants/signUpOptions"
import authentication from "@irati/auth"
import SAMLSingleSignOn from "@irati-web/admin/src/components/Settings/CompanySignUpSettings/SAMLSingleSignOn"
import notify from "@irati/utils/notify"

interface Props extends InjectIntl {
  setIsStepCompletable: (value: boolean) => void
}

class PromoMaterials extends PureComponent<Props> {
  checkIfStepIsCompletable = () => {
    const {setIsStepCompletable, formatMessage} = this.props
    const userTenant = authentication.userTenant()
    if (userTenant.settings.signUpOption === SSO_TYPE_SAML) {
      setIsStepCompletable(true)
      notify.success({message: formatMessage({id: "setup_tenant.steps.setupSSO.successMessage"})})
    }
  }

  render() {
    const userTenant = authentication.userTenant()

    return (
      <>
        <SAMLSingleSignOn
          ssoButtonText={userTenant.settings.ssoButtonText}
          userTenant={userTenant}
          handleSave={this.checkIfStepIsCompletable}
          hideDocHint />
      </>
    )
  }
}

export default injectIntl(PromoMaterials)
